// Generated by Melange

import * as Cn from "../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

const loadingDiv = "flex h-full w-full items-center justify-center";

const Styles = {
  loadingDiv: loadingDiv
};

function make(sizeOpt) {
  const size = sizeOpt !== undefined ? sizeOpt : "w-9 h-9";
  return function (borderWidthOpt) {
    const borderWidth = borderWidthOpt !== undefined ? borderWidthOpt : "border-4";
    return function (primaryColorOpt) {
      const primaryColor = primaryColorOpt !== undefined ? primaryColorOpt : "border-links";
      return function (secondaryColorOpt) {
        const secondaryColor = secondaryColorOpt !== undefined ? secondaryColorOpt : "border-t-default-gray";
        return function (className) {
          return JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            className: Cn.fromList({
                                  hd: "animate-spin rounded-full",
                                  tl: {
                                    hd: size,
                                    tl: {
                                      hd: borderWidth,
                                      tl: {
                                        hd: primaryColor,
                                        tl: {
                                          hd: secondaryColor,
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                })
                          }),
                      className: Cn.fromList({
                            hd: loadingDiv,
                            tl: {
                              hd: Cn.take(className),
                              tl: /* [] */0
                            }
                          })
                    });
        };
      };
    };
  };
}

function LoadingDiv(Props) {
  return Curry._3(make(Props.size)(Props.borderWidth), Props.primaryColor, Props.secondaryColor, Props.className);
}

const make$1 = LoadingDiv;

export {
  Styles ,
  make$1 as make,
}
/* react/jsx-runtime Not a pure module */
